import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import { ENDPOINTS } from "../Helper/endpoints";
// import { jsPDF } from "jspdf";
import "jspdf-autotable";
import Swal from "sweetalert2";
import Footer from "./Footer";
// import { debounce } from "lodash";
import { FaCog } from "react-icons/fa"; // Import gear icon
import html2pdf from "html2pdf.js";

const getCookie = (cookieName) => {
  const cookies = document.cookie.split("; ");
  for (let cookie of cookies) {
    const [name, value] = cookie.split("=");
    if (name === cookieName) return decodeURIComponent(value);
  }
  return null;
};
const PRList = ({ setCurrentPage, row }) => {
  const [tableData, setTableData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [organizationLogo, setOrganizationLogo] = useState("/default-logo.jpg");
  // const [showMenu, setShowMenu] = useState(false);
  const [activeRow, setActiveRow] = useState(null);
  // const [userInfo, setUserInfo] = useState(null);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [selectedPR, setSelectedPR] = useState(null);
  const menuRef = useRef(null);
  const [formData, setFormData] = useState({
    pr_no: "",
    invoice_no: "",
    pr_date: "",
    invoice_date: "",
    net_payable: "",
    total_amount: "",
    CGST: "",
    SGST: "",
    advance: "",
    round_off: "",
    TDS: "",
    TDS_section: "",
    TDS_percentage: "",
    other_charges: "",
    reference: "",
    outstanding: "",
    Debit_note: "",
    Retention: "",
    description: [],
  });

  const fetchTableData = useCallback(() => {
  const userSessionData = getCookie("userSession");
  if (!userSessionData) return;

  try {
    const parsedSessionData = JSON.parse(userSessionData);
    const pid = parsedSessionData.data.user_info.organizations_pid;
    const organization_logo =
      parsedSessionData?.data?.organization_logo || "/default-logo.jpg";
    setOrganizationLogo(organization_logo);

    axios
      .get(ENDPOINTS.INVOICES_INFO, { params: { organizations_pid: pid } })
      .then((response) => {
        if (response.data && Array.isArray(response.data.data)) {
          setTableData(response.data.data);
        }
      });

    axios
      .get(ENDPOINTS.PR_SEARCH, {
        params: { organization_pid: pid, search_term: searchTerm },
      })
      .then((response) => {
        if (response.data && Array.isArray(response.data.data)) {
          setSearchResults(response.data.data);
        }
      });

  } catch (e) {
    console.error(e);
  }
}, [searchTerm]);
  // const debouncedSearch = debounce((value) => {
  //   fetchTableData(value);
  // }, 1000);
  // Handle search input
  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    const filteredData = tableData.filter(
      (row) =>
        row.name.toLowerCase().includes(value) ||
        row.pr_no.toLowerCase().includes(value) ||
        row.invoice_no.toLowerCase().includes(value)
    );

    setSearchResults(filteredData);
  };
  // Run once when component mounts
  useEffect(() => {
  fetchTableData();
}, [fetchTableData]);
  // Function to handle delete
  const handleDeleteClick = (pr_pid) => {
    const organization_pid = getCookie("userSession")
      ? JSON.parse(getCookie("userSession")).data.user_info.organizations_pid
      : null;

    if (!organization_pid) {
      Swal.fire({
        title: "Error",
        text: "Organization information is missing",
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
        customClass: { popup: "small-swal-popup" },
      });
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
      customClass: {
        popup: "small-swal-popup",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Processing...",
          text: "Please wait while we delete the PR.",
          icon: "info",
          timer: 1500,
          showConfirmButton: false,
          customClass: { popup: "small-swal-popup" },
        });

        axios
          .delete(ENDPOINTS.PR_DELETE, {
            params: { organization_pid, PR_pid: pr_pid },
          })
          .then(() => {
            Swal.fire({
              title: "Deleted!",
              text: "PR has been deleted.",
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              customClass: { popup: "small-swal-popup" },
            }).then(() => {
              fetchTableData(); // ✅ Reload table after deletion
            });
          })
          .catch((error) => {
            console.error("Error deleting PR:", error);
            Swal.fire({
              title: "Error",
              text: "Failed to delete PR. Please try again.",
              icon: "error",
              timer: 1500,
              showConfirmButton: false,
              customClass: { popup: "small-swal-popup" },
            });
          });
      }
    });
  };
  // Function to handle pdf
  const loadImageToBase64 = async (imgPath, maxWidth = 80, maxHeight = 120) => {
    try {
      const response = await fetch(imgPath, { credentials: "include" });
      if (!response.ok) throw new Error("Failed to fetch image");
      
      const blob = await response.blob();
      
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const img = new Image();
          img.src = reader.result;
          
          img.onload = () => {
            let { width, height } = img;
            
            // Maintain aspect ratio
            if (width > maxWidth || height > maxHeight) {
              const scaleFactor = Math.min(
                maxWidth / width,
                maxHeight / height
              );
              width = Math.round(width * scaleFactor);
              height = Math.round(height * scaleFactor);
            }
            
            resolve({
              base64: reader.result,
              width,
              height,
            });
          };
          
          img.onerror = () =>
            reject(new Error("Error loading image for resizing"));
        };
        
        reader.onerror = () =>
          reject(new Error("Failed to convert image to Base64"));
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Error fetching logo:", error);
      return { base64: "", width: 80, height: 120 }; // Default size if error occurs
    }
  };

  const handleDownloadClick = async (invoice) => {
    try {
      if (!organizationLogo) throw new Error("Organization logo not set");
  
      const { base64: logoBase64 } = await loadImageToBase64(organizationLogo, 100, 80);
      
      // Create a new container element that will be off-screen
      const offscreenContainer = document.createElement('div');
      offscreenContainer.id = "invoice-print-offscreen";
      offscreenContainer.style.position = "absolute";
      offscreenContainer.style.left = "-9999px";
      offscreenContainer.style.top = "-9999px";
      
      // Clone your invoice template
      const invoiceTemplate = document.getElementById("invoice-print").cloneNode(true);
      invoiceTemplate.style.display = "block"; // Make sure it's set to display
      offscreenContainer.appendChild(invoiceTemplate);
      document.body.appendChild(offscreenContainer);
      
      // Now use the cloned elements for setting content
      const container = offscreenContainer;
      container.querySelector("#invoice-logo").src = logoBase64;
      
      // Fill org details (update selectors to work within container)
      container.querySelector("#org-name").innerText = invoice.org_name;
      container.querySelector("#org-address").innerText = invoice.org_address;
      container.querySelector("#org-gstin").innerText = `GSTIN: ${invoice.org_GSTIN}`;
      container.querySelector("#org-phone").innerText = `Phone: ${invoice.org_phone}`;
      container.querySelector("#org-email").innerText = `Email: ${invoice.org_email}`;
  
      // Fill client details
      container.querySelector("#client-name").innerText = invoice.name;
      container.querySelector("#client-address").innerText = invoice.address;
      container.querySelector("#client-gstin").innerText = `GSTIN: ${invoice.GSTIN}`;
      container.querySelector("#client-phone").innerText = `Phone: ${invoice.mobile}`;
      container.querySelector("#client-email").innerText = `Email: ${invoice.email}`;
      container.querySelector("#pr-no").innerText = invoice.pr_no || "NA";
      container.querySelector("#reference").innerText = invoice.reference || "NA";
      container.querySelector("#transaction-no").innerText = invoice.transaction_no || "";
  
      container.querySelector("#pr-date").innerText = invoice.pr_date || "NA";
      container.querySelector("#invoice-no").innerText = invoice.invoice_no || "NA";
      container.querySelector("#due-date").innerText = invoice.due_date || invoice.pr_date || "NA";
  
      // Fill invoice items
      const tbody = container.querySelector("#invoice-items");
      tbody.innerHTML = "";
      invoice.description.forEach((item) => {
        const tr = document.createElement("tr");
        tr.innerHTML = `
          <td style="padding: 8px; text-align: center">${item.item}</td>
          <td style="padding: 8px; text-align: center">${item.HSN_SAC}</td>
          <td style="padding: 8px; text-align: center">${item.GST}%</td>
          <td style="padding: 8px; text-align: center">${item.quantity}</td>
          <td style="padding: 8px; text-align: center">${(item.Amount / item.quantity).toFixed(2)}</td>
          <td style="padding: 8px; text-align: center">${item.Amount.toFixed(2)}</td>
          <td style="padding: 8px; text-align: center">${(item.Amount + item.CGST + item.SGST).toFixed(2)}</td>
        `;
        tbody.appendChild(tr);
      });
      
      // Fill bank details
      container.querySelector("#bank-details").innerHTML = `
        <strong>Account Name:</strong> ${invoice.account_holder_name}<br />
        <strong>Account Number:</strong> ${invoice.account_number}<br />
        <strong>Bank:</strong> ${invoice.bank_name}<br />
        <strong>IFSC Code:</strong> ${invoice.IFSC_code}<br />
        <strong>Branch:</strong> ${invoice.branch}<br />
        <strong>UPI ID:</strong> ${invoice.UPI_ID}
      `;
  
      // Fill totals
      const totalsContainer = container.querySelector("#invoice-totals");
      const formatCurrency = (num) => `Rs. ${Number(num || 0).toFixed(2)}`;
  
      // Create the HTML structure for totals
      let totalsHTML = `
        <div style="display: flex; justify-content: space-between; margin-bottom: 8px">
          <div>Subtotal</div>
          <div>${formatCurrency(invoice.total_amount)}</div>
        </div>
        <div style="display: flex; justify-content: space-between; margin-bottom: 8px">
          <div>Total CGST</div>
          <div>${formatCurrency(invoice.CGST)}</div>
        </div>
        <div style="display: flex; justify-content: space-between; margin-bottom: 8px">
          <div>Total SGST</div>
          <div>${formatCurrency(invoice.SGST)}</div>
        </div>
        <div style="display: flex; justify-content: space-between; margin-bottom: 8px">
          <div>Round Off</div>
          <div>${formatCurrency(invoice.round_off)}</div>
        </div>
      `;
  
      // Add conditional items only if they exist and are not zero
      if (invoice.TDS && Number(invoice.TDS) !== 0) {
        totalsHTML += `
          <div style="display: flex; justify-content: space-between; margin-bottom: 8px">
            <div>TDS</div>
            <div>${formatCurrency(invoice.TDS)}</div>
          </div>
        `;
      }
  
      if (invoice.other_charges && Number(invoice.other_charges) !== 0) {
        totalsHTML += `
          <div style="display: flex; justify-content: space-between; margin-bottom: 8px">
            <div>Other Charges</div>
            <div>${formatCurrency(invoice.other_charges)}</div>
          </div>
        `;
      }
  
      if (invoice.advance && Number(invoice.advance) !== 0) {
        totalsHTML += `
          <div style="display: flex; justify-content: space-between; margin-bottom: 8px">
            <div>Advance</div>
            <div>${formatCurrency(invoice.advance)}</div>
          </div>
        `;
      }
  
      if (invoice.debit_note && Number(invoice.debit_note) !== 0) {
        totalsHTML += `
          <div style="display: flex; justify-content: space-between; margin-bottom: 8px">
            <div>Debit Note</div>
            <div>${formatCurrency(invoice.debit_note)}</div>
          </div>
        `;
      }
  
      if (invoice.retention && Number(invoice.retention) !== 0) {
        totalsHTML += `
          <div style="display: flex; justify-content: space-between; margin-bottom: 8px">
            <div>Retention</div>
            <div>${formatCurrency(invoice.retention)}</div>
          </div>
        `;
      }
  
      if (invoice.outstanding && Number(invoice.outstanding) !== 0) {
        totalsHTML += `
          <div style="display: flex; justify-content: space-between; margin-bottom: 8px">
            <div>Outstanding</div>
            <div>${formatCurrency(invoice.outstanding)}</div>
          </div>
        `;
      }
      
      // Add divider before Net Payable
      totalsHTML += `<hr style="border: 1px solid black; margin: 15px 0;" />`;
  
      // Add Net Payable with bold formatting
      totalsHTML += `
        <div style="display: flex; justify-content: space-between; margin-bottom: 8px; font-weight: bold; font-size: 16px;">
          <div>Net Payable</div>
          <div>Rs. ${Number(invoice.net_payable || 0).toFixed(2)}</div>
        </div>
      `;
  
      totalsContainer.innerHTML = totalsHTML;
  
      // Signatures
      container.querySelector("#prepared-by-name").innerText = invoice.Created_by_name;
      container.querySelector("#checked-by-name").innerText = invoice.Checked_by_name;
      container.querySelector("#approved-by-name").innerText = invoice.Approved_by_name;
  
      // Generate PDF using the off-screen element
      await new Promise((res) => setTimeout(res, 100)); // give time to render
  
      const opt = {
        margin: 0.5,
        filename: `${invoice.name}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };
  
      // Generate from the offscreen element
      await html2pdf().set(opt).from(invoiceTemplate).save();
  
      // Clean up - remove the offscreen container
      document.body.removeChild(offscreenContainer);
    } catch (error) {
      console.error("Error generating invoice PDF:", error);
      Swal.fire({
        title: "Error",
        text: "Failed to generate invoice PDF.",
        icon: "error",
      });
    }
  };

  // Function to handle status
  const handleChangeStatusClick = async (pr_pid, organization_pid) => {
    try {
      console.log("🚀 handleChangeStatusClick triggered with:", { pr_pid, organization_pid });

      // Show loading indicator
      Swal.fire({
        title: "Loading bank details...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      // Fetch bank info
      const bankResponse = await axios.get(ENDPOINTS.BANK_INFO, { params: { organization_pid } });
      console.log("✅ Bank API Response:", bankResponse.data);

      // Extract banks array from response
      let banks = null;

      if (Array.isArray(bankResponse.data?.banks)) {
        banks = bankResponse.data.banks;
      } else if (Array.isArray(bankResponse.data?.data?.banks)) {
        banks = bankResponse.data.data.banks;
      } else if (Array.isArray(bankResponse.data?.data)) {
        banks = bankResponse.data.data;
      } else if (Array.isArray(bankResponse.data)) {
        banks = bankResponse.data;
      }

      console.log("✅ Extracted banks data:", banks);

      // Validate banks data
      if (!Array.isArray(banks)) {
        console.error("❌ Invalid banks array:", banks);
        Swal.fire({
          title: "Error",
          text: "No bank data available.",
          icon: "error"
        });
        return;
      }

      // Close loading indicator
      Swal.close();

      // Identify the correct property names in the bank objects
      const firstBank = banks[0] || {};
      const idField = Object.keys(firstBank).find(k => k.includes('id') || k === 'id') || 'id';
      const nameField = Object.keys(firstBank).find(k => k.includes('name')) || 'name';
      const accountField = Object.keys(firstBank).find(k => k.includes('account') || k.includes('number')) || 'account_number';

      console.log("✅ Using bank fields:", { idField, nameField, accountField });

      // Create HTML options for the select dropdown
      const options = banks.map(bank => {
        const id = bank[idField];
        const name = bank[nameField] || 'Unknown Bank';
        const account = bank[accountField] || 'N/A';
        return `<option value="${id}">${name} (Acc: ${account})</option>`;
      }).join('');

      // Include an "N/A" option
      const selectHTML = `
        <div class="bank-select-container">
          <label for="bank-selection" class="bank-select-label">Choose a bank</label>
          <select id="bank-selection" class="bank-select-dropdown">
            <option value="" disabled selected>Select bank account</option>
            <option value="NA">N/A (No Bank Selected)</option>
            ${options}
          </select>
        </div>
      `;

      // Show SweetAlert2 modal
      Swal.fire({
        title: 'Select a Bank',
        html: selectHTML,
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        customClass: {
          confirmButton: 'bank-select-btn-confirm',
          cancelButton: 'bank-select-btn-cancel'
        },
        buttonsStyling: true,
        focusConfirm: false,
        preConfirm: () => {
          const selectedBankId = document.getElementById('bank-selection').value;
          if (!selectedBankId) {
            Swal.showValidationMessage('Please select a bank');
            return false;
          }
          return selectedBankId;
        }
      }).then((result) => {
        if (result.isConfirmed && result.value) {
          const selectedBankId = result.value;
          const selectedBank = banks.find(bank => bank[idField] === selectedBankId);
          const bankName = selectedBank ? (selectedBank[nameField] || 'Selected Bank') : (selectedBankId === "NA" ? "N/A" : "Selected Bank");

          console.log("✅ User selected bank:", { selectedBankId, bankName });

          // Call API to update status with "NA" if N/A is selected
          axios.put(ENDPOINTS.CHANGE_PR_STATUS, null, {
            params: {
              pr_pid: pr_pid,
              BankDetails_pid: selectedBankId // Send "NA" if "N/A" is selected
            }
          })
            .then((response) => {
              console.log("✅ PR Status Update Response:", response.data);

              if (response.data.data?.status) {
                Swal.fire({
                  title: "Status Updated!",
                  text: `PR status changed using Bank: ${bankName}.`,
                  icon: "success",
                  showConfirmButton: true,
                  customClass: { popup: "small-swal-popup" },
                }).then(() => {
                  fetchTableData();
                });

                setTableData((prevData) =>
                  prevData.map((row) =>
                    row.pr_no === pr_pid ? { ...row, status: response.data.data.status } : row
                  )
                );
              } else {
                throw new Error(response.data.message || "Failed to update status.");
              }
            })
            .catch((error) => {
              console.error("❌ Error updating PR status:", error);
              Swal.fire({ title: "Error", text: "Failed to update PR status.", icon: "error" });
            });
        }
      });
    } catch (error) {
      console.error("❌ Error in handleChangeStatusClick:", error);
      Swal.fire({
        title: "Error",
        text: error.message || "An unexpected error occurred.",
        icon: "error"
      });
    }
  };



  const handleUpdate = (pr_pid) => {
    const selectedPR = tableData.find((row) => row.pid === pr_pid);
    if (selectedPR) {
      setFormData({
        pr_no: selectedPR.pr_no || "",
        invoice_no: selectedPR.invoice_no || "",
        pr_date: selectedPR.pr_date || "",
        invoice_date: selectedPR.invoice_date || "",
        net_payable: selectedPR.net_payable || "",
        total_amount: selectedPR.total_amount || "",
        CGST: selectedPR.CGST || "",
        SGST: selectedPR.SGST || "",
        advance: selectedPR.advance || "",
        round_off: selectedPR.round_off || "",
        TDS: selectedPR.TDS || "",
        TDS_section: selectedPR.TDS_section || "",
        TDS_percentage: selectedPR.TDS_percentage || "",
        other_charges: selectedPR.other_charges || "",
        reference: selectedPR.reference || "",
        outstanding: selectedPR.outstanding || "",
        Debit_note: selectedPR.Debit_note || "",
        Retention: selectedPR.Retention || "",
        description:
          selectedPR.description?.map((row) => ({
            item: row.item || "",
            HSN_SAC: row.HSN_SAC || "",
            unit: row.unit || "",
            quantity: Number(row.quantity) || 0,
            GST: Number(row.GST) || 0,
            CGST: Number(row.CGST) || 0,
            SGST: Number(row.SGST) || 0,
            Amount: Number(row.Amount) || 0,
          })) || [],
      });
      setSelectedPR(selectedPR);
      setShowUpdateForm(true);
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => {
      const updatedFormData = {
        ...prevData,
        [name]: value,
      };

      // Recalculate totals when TDS percentage or other fields that affect calculations change
      if (['TDS_percentage', 'other_charges', 'advance', 'Debit_note', 'Retention', 'outstanding'].includes(name)) {
        const {
          totalAmount,
          totalCGST,
          totalSGST,
          roundOff,
          netPayable,
          tdsAmount,
        } = calculateTotals(prevData.description, updatedFormData);

        return {
          ...updatedFormData,
          total_amount: totalAmount.toFixed(2),
          CGST: totalCGST.toFixed(2),
          SGST: totalSGST.toFixed(2),
          TDS: tdsAmount.toFixed(2),
          round_off: roundOff.toFixed(2),
          net_payable: netPayable.toFixed(2),
        };
      }

      return updatedFormData;
    });
  };

  const calculateTotals = (updatedDescription, formData) => {
    let totalAmount = 0;
    let totalCGST = 0;
    let totalSGST = 0;

    updatedDescription.forEach((item) => {
      const amount = Number(item.Amount) || 0;
      const GST = Number(item.GST) || 0;
      const CGST = (amount * (GST / 2)) / 100;
      const SGST = (amount * (GST / 2)) / 100;

      totalAmount += amount;
      totalCGST += CGST;
      totalSGST += SGST;
    });

    const totalBeforeTDS = totalAmount + totalCGST + totalSGST;
    const tdsAmount = (totalBeforeTDS * (parseFloat(formData.TDS_percentage) || 0)) / 100;
    const totalAfterTDS = totalBeforeTDS - tdsAmount;
    const totalAfterOtherCharges = totalAfterTDS - Number(formData.other_charges || 0);

    const totalBeforeRoundoff =
      totalAfterOtherCharges -
      Number(formData.advance || 0) -
      Number(formData.Debit_note || 0) -
      Number(formData.Retention || 0) +
      Number(formData.outstanding || 0);
    const roundOff = Math.round(totalBeforeRoundoff) - totalBeforeRoundoff;
    const netPayable = totalBeforeRoundoff + roundOff;

    return {
      totalAmount,
      totalCGST,
      totalSGST,
      roundOff,
      netPayable,
      tdsAmount,
    };
  };

  // Add these functions to your component
  const addDescriptionRow = () => {
    setFormData({
      ...formData,
      description: [
        ...formData.description,
        { item: "", HSN_SAC: "", GST: "", quantity: "", Amount: "" }
      ]
    });
  };

  const removeDescriptionRow = () => {
    if (formData.description.length === 1) {
      // You might want to use your Swal here for consistency
      Swal.fire({
        icon: 'warning', text: 'At least one row required!',
        confirmButtonText: 'OK', customClass: { popup: 'small-swal-popup', },
      }); return;
    }

    const updatedDescription = formData.description.slice(0, -1);

    // Recalculate totals after removing a row
    const {
      totalAmount,
      totalCGST,
      totalSGST,
      roundOff,
      netPayable,
      tdsAmount,
    } = calculateTotals(updatedDescription, formData);

    setFormData({
      ...formData,
      description: updatedDescription,
      total_amount: totalAmount.toFixed(2),
      CGST: totalCGST.toFixed(2),
      SGST: totalSGST.toFixed(2),
      TDS: tdsAmount.toFixed(2),
      round_off: roundOff.toFixed(2),
      net_payable: netPayable.toFixed(2),
    });
  };

  const handleDescriptionChange = (index, field, value) => {
    setFormData((prevData) => {
      const updatedDescription = [...prevData.description];
      updatedDescription[index] = {
        ...updatedDescription[index],
        [field]: value,
      };

      // Recalculate all totals
      const {
        totalAmount,
        totalCGST,
        totalSGST,
        roundOff,
        netPayable,
        tdsAmount,
      } = calculateTotals(updatedDescription, prevData);

      return {
        ...prevData,
        description: updatedDescription,
        total_amount: totalAmount.toFixed(2),
        CGST: totalCGST.toFixed(2),
        SGST: totalSGST.toFixed(2),
        TDS: tdsAmount.toFixed(2),
        round_off: roundOff.toFixed(2),
        net_payable: netPayable.toFixed(2),
      };
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    console.log("Selected PR:", selectedPR);

    if (!selectedPR) {
      console.warn("Error: No PR selected for update!");
      return;
    }

    const pr_pid = selectedPR.pid; // Extract PR ID for query param

    // Construct payload with only required fields (excluding pr_pid)
    const payload = {
      vendors_pid: selectedPR.vendors_pid,
      organizations_pid: selectedPR.organizations_pid,
      pr_date: formData.pr_date,
      total_amount: formData.total_amount,
      net_payable: formData.net_payable,
      CGST: formData.CGST,
      SGST: formData.SGST,
      round_off: formData.round_off,
      description: formData.description.map((item) => ({
        item: item.item,
        unit: item.unit,
        quantity: item.quantity,
        GST: item.GST,
        Amount: item.Amount,
      })),
      name: formData.name,
      address: formData.address,
      GSTIN: formData.GSTIN,
      pan_card_no: formData.pan_card_no,
      aadhar_no: formData.aadhar_no,
      mobile: formData.mobile,
      email: formData.email,
      account_holder_name: formData.account_holder_name,
      account_number: formData.account_number,
      IFSC_code: formData.IFSC_code,
      bank_name: formData.bank_name,
      branch: formData.branch,
      UPI_ID: formData.UPI_ID,
    };

    axios
      .put(`${ENDPOINTS.PR_UPDATE}?pr_pid=${pr_pid}`, payload) // Sending PR PID as a query param
      .then((response) => {
        console.log("API Response:", response.data); // ✅ Log API response
        if (response.status === 200) {
          setTableData((prevTableData) =>
            prevTableData.map((pr) =>
              pr.pid === pr_pid ? { ...pr, ...formData } : pr
            )
          );
          setShowUpdateForm(false);
          setSelectedPR(null);
          Swal.fire({
            title: "Updated!",
            text: "PR has been updated successfully.",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
            customClass: { popup: "small-swal-popup" },
          });
        }
      })
      .catch((error) => {
        console.error("Error updating PR:", error.response?.data || error); // ✅ Log API errors
        Swal.fire({
          title: "Error!",
          text: "Failed to update PR.",
          icon: "error",
          timer: 1500,
          showConfirmButton: false,
          customClass: { popup: "small-swal-popup" },
        });
      });
  };

  // const handleMenuToggle = (rowId) => {
  //   setActiveRow(activeRow === rowId ? null : rowId);
  // };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setActiveRow(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="vendor-list">
        <div
          className="vendor-list-header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <h2>Payment Recommendation List</h2>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <input
              type="text"
              placeholder="Search Payment Recommendation"
              value={searchTerm}
              onChange={handleSearchChange}
              className="search-input"
            />
            <button
              className="create-button"
              onClick={() => setCurrentPage("GSTInvoice")}
            >
              Create PR
            </button>
          </div>
          <div id="invoice-print" style={{ display: "none", padding: "20px", fontFamily: "Lexend, sans-serif" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <img 
  id="invoice-logo" 
  src="" 
  alt="Logo" 
  style={{ 
    maxHeight: "120px", 
    maxWidth: "80px", 
    objectFit: "contain" 
  }} 
/>

              <div style={{ textAlign: "right" }}>
                <strong id="org-name" style={{ fontSize: "16px" }}></strong>
                <br />
                <span id="org-address"></span>
                <br />
                <span id="org-gstin"></span>
                <br />
                <span id="org-phone"></span>
                <br />
                <span id="org-email"></span>
              </div>
            </div>

            <h2 style={{ textAlign: "center", marginTop: "20px", marginBottom: "20px" }}>
              PAYMENT RECOMMENDATION
            </h2>

            <div style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "10px",
              borderTop: "1px solid #ccc",
              borderBottom: "1px solid #ccc",
              paddingTop: "15px",
              paddingBottom: "15px"
            }}>
              <div>
                <strong>Bill To</strong>
                <br />
                <strong id="client-name"></strong>
                <br />
                <span id="client-address"></span>
                <br />
                <span id="client-gstin"></span>
                <br />
                <span id="client-phone"></span>
                <br />
                <span id="client-email"></span>
              </div>
              <div style={{ textAlign: "right" }}>
                <strong>PR#</strong> <span id="pr-no"></span>
                <br />
                <strong>Reference:</strong> <span id="reference"></span>
                <br />
                <strong>Transaction No:</strong> <span id="transaction-no"></span>
              </div>
            </div>

            {/* PR/Invoice/Due Date Table */}
            <table style={{
              width: "100%",
              marginTop: "15px",
              borderCollapse: "collapse",
              border: "1px solid black",
              fontSize: "12px"
            }}>
              <thead style={{ backgroundColor: "#001F56", color: "white" }}>
                <tr>
                  <th style={{ padding: "8px", borderBottom: "1px solid black", textAlign: "center" }}>PR Date</th>
                  <th style={{ padding: "8px", borderBottom: "1px solid black", textAlign: "center" }}>Invoice No</th>
                  <th style={{ padding: "8px", borderBottom: "1px solid black", textAlign: "center" }}>Due Date</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td id="pr-date" style={{ padding: "8px", textAlign: "center" }}></td>
                  <td id="invoice-no" style={{ padding: "8px", textAlign: "center" }}></td>
                  <td id="due-date" style={{ padding: "8px", textAlign: "center" }}></td>
                </tr>
              </tbody>
            </table>

            {/* Items Table */}
            <table style={{
              width: "100%",
              marginTop: "20px",
              borderCollapse: "collapse",
              border: "1px solid black",
              fontSize:"12px"
            }}>
              <thead style={{ backgroundColor: "#001F56", color: "white" }}>
                <tr>
                  <th style={{ padding: "8px", borderBottom: "1px solid black", textAlign: "center" }}>Item</th>
                  <th style={{ padding: "8px", borderBottom: "1px solid black", textAlign: "center" }}>HSN/SAC</th>
                  <th style={{ padding: "8px", borderBottom: "1px solid black", textAlign: "center" }}>GST(%)</th>
                  <th style={{ padding: "8px", borderBottom: "1px solid black", textAlign: "center" }}>Qty</th>
                  <th style={{ padding: "8px", borderBottom: "1px solid black", textAlign: "center" }}>Rate</th>
                  <th style={{ padding: "8px", borderBottom: "1px solid black", textAlign: "center" }}>Amount</th>
                  <th style={{ padding: "8px", borderBottom: "1px solid black", textAlign: "center" }}>Total + GST</th>
                </tr>
              </thead>
              <tbody id="invoice-items"></tbody>
            </table>

            {/* Bank Details and Totals Side by Side */}
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
              gap: "30px"
            }}>
              {/* Account Details */}
              <div style={{ flex: 1 }}>
                <h3 style={{ paddingBottom: "5px", marginTop: "0", fontSize: "16px" }}>Account Details</h3>
                <div id="bank-details" style={{ lineHeight: "1.5", fontSize: "12px" }}></div>
              </div>

              {/* Totals - Right aligned with proper formatting */}
              <div style={{ flex: 1 }}>
                <div id="invoice-totals" style={{ width: "100%", fontSize: "12px" }}></div>
              </div>
            </div>

            {/* Signatures */}
            <div style={{
              marginTop: "50px",
              display: "flex",
              justifyContent: "space-between",
              textAlign: "center"
            }}>
              <div style={{ flex: 1, maxWidth: "30%" }}>
                <div id="prepared-by-name"></div>
                <hr style={{ width: "100%" }} />
                <span>Prepared by</span>
              </div>
              <div style={{ flex: 1, maxWidth: "30%" }}>
                <div id="checked-by-name"></div>
                <hr style={{ width: "100%" }} />
                <span>Checked by</span>
              </div>
              <div style={{ flex: 1, maxWidth: "30%" }}>
                <div id="approved-by-name"></div>
                <hr style={{ width: "100%" }} />
                <span>Approved by</span>
              </div>
            </div>
          </div>



        </div>
        {showUpdateForm && (
          <div
            className="update-form-container"
            style={{
              marginBottom: "20px",
              padding: "20px",
              border: "1px solid #ddd",
              borderRadius: "8px",
              backgroundColor: "#f9f9f9",
            }}
          >
            <h3>Update PR</h3>
            <form
              onSubmit={handleFormSubmit}
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "15px",
              }}
            >
              <div>
                <label>PR No:</label>
                <input
                  type="text"
                  name="pr_no"
                  value={formData.pr_no}
                  onChange={handleInputChange}
                  disabled
                />
              </div>

              <div>
                <label>Invoice No:</label>
                <input
                  type="text"
                  name="invoice_no"
                  value={formData.invoice_no}
                  onChange={handleInputChange}
                />
              </div>

              <div>
                <label>PR Date:</label>
                <input
                  type="date"
                  name="pr_date"
                  value={formData.pr_date}
                  onChange={handleInputChange}
                />
              </div>

              <div>
                <label>Invoice Date:</label>
                <input
                  type="date"
                  name="invoice_date"
                  value={formData.invoice_date}
                  onChange={handleInputChange}
                />
              </div>

              <div>
                <label>Reference:</label>
                <input
                  type="text"
                  name="reference"
                  value={formData.reference}
                  onChange={handleInputChange}
                />
              </div>

              <div>
                <label>Total Amount:</label>
                <input
                  type="number"
                  name="total_amount"
                  value={formData.total_amount}
                  readOnly
                />
              </div>

              <div>
                <label>CGST:</label>
                <input
                  type="number"
                  name="CGST"
                  value={formData.CGST}
                  readOnly
                />
              </div>

              <div>
                <label>SGST:</label>
                <input
                  type="number"
                  name="SGST"
                  value={formData.SGST}
                  readOnly
                />
              </div>

              <div>
                <label>Round Off:</label>
                <input
                  type="number"
                  name="round_off"
                  value={formData.round_off}
                  readOnly
                />
              </div>

              <div>
                <label>TDS Percentage:</label>
                <input
                  type="number"
                  step="0.01"
                  name="TDS_percentage"
                  value={formData.TDS_percentage}
                  onChange={handleInputChange}
                />
              </div>

              <div>
                <label>TDS Section</label>
                <input
                  type="text"
                  name="TDS_section"
                  value={formData.TDS_section}
                  onChange={handleInputChange}
                />
              </div>

              <div>
                <label>TDS:</label>
                <input
                  type="number"
                  name="TDS"
                  value={formData.TDS}
                  readOnly
                />
              </div>

              <div>
                <label>Advance:</label>
                <input
                  type="number"
                  name="advance"
                  value={formData.advance}
                  onChange={handleInputChange}
                />
              </div>

              <div>
                <label>Other Charges:</label>
                <input
                  type="number"
                  name="other_charges"
                  value={formData.other_charges}
                  onChange={handleInputChange}
                />
              </div>

              <div>
                <label>Outstanding:</label>
                <input
                  type="text"
                  name="outstanding"
                  value={formData.outstanding}
                  onChange={handleInputChange}
                />
              </div>

              <div>
                <label>Debit Note:</label>
                <input
                  type="number"
                  name="Debit_note"
                  value={formData.Debit_note}
                  onChange={handleInputChange}
                />
              </div>

              <div>
                <label>Retention</label>
                <input
                  type="number"
                  name="Retention"
                  value={formData.Retention}
                  onChange={handleInputChange}
                />
              </div>

              <div>
                <label>Net Payable:</label>
                <input
                  type="number"
                  name="net_payable"
                  value={formData.net_payable}
                  readOnly
                />
              </div>

              {/* Description Section */}
              <div style={{ gridColumn: "span 2" }}>
                <h4>Description</h4>
                {formData.description.map((desc, index) => {
                  // Calculate Total + GST for each row
                  const amount = Number(desc.Amount || 0);
                  const gstRate = Number(desc.GST || 0);
                  const gstAmount = (amount * gstRate / 100);
                  const totalWithGST = amount + gstAmount;

                  return (
                    <div
                      key={index}
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr",
                        gap: "10px",
                        marginBottom: "10px",
                      }}
                    >
                      <input
                        type="text"
                        placeholder="Item"
                        value={desc.item}
                        onChange={(e) =>
                          handleDescriptionChange(index, "item", e.target.value)
                        }
                      />
                      <input
                        type="text"
                        placeholder="HSN/SAC"
                        value={desc.HSN_SAC}
                        onChange={(e) =>
                          handleDescriptionChange(index, "HSN_SAC", e.target.value)
                        }
                      />
                      <input
                        type="number"
                        placeholder="GST %"
                        value={desc.GST}
                        onChange={(e) =>
                          handleDescriptionChange(index, "GST", e.target.value)
                        }
                      />
                      <input
                        type="number"
                        placeholder="Quantity"
                        value={desc.quantity}
                        onChange={(e) =>
                          handleDescriptionChange(
                            index,
                            "quantity",
                            e.target.value
                          )
                        }
                      />
                      <input
                        type="number"
                        placeholder="Amount"
                        value={desc.Amount}
                        onChange={(e) =>
                          handleDescriptionChange(
                            index,
                            "Amount",
                            e.target.value
                          )
                        }
                      />
                      <input
                        type="number"
                        placeholder="Total+GST"
                        value={totalWithGST.toFixed(2)}
                        readOnly
                      />
                    </div>
                  );
                })}

                {/* Add/Remove row buttons moved below the fields */}
                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px", marginBottom: "20px" }}>
                  <button
                    type="button"
                    onClick={addDescriptionRow}
                    style={{ marginRight: '10px', padding: '6px 12px', backgroundColor: "#191056", color: 'white', border: 'none', borderRadius: '4px', fontSize: '20px' }}
                  >
                    +
                  </button>
                  <button
                    type="button"
                    onClick={removeDescriptionRow}
                    style={{ padding: '6px 12px', backgroundColor: "#191056", color: 'white', border: 'none', borderRadius: '4px', fontSize: '20px' }}
                  >
                    -
                  </button>
                </div>
              </div>

              <div
                style={{ display: "flex", gap: "10px", gridColumn: "span 2" }}
              >
                <button
                  type="submit"
                  style={{
                    padding: "8px 16px",
                    backgroundColor: "#191056",
                    color: "white",
                    borderRadius: "5px",
                  }}
                >
                  Update PR
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setShowUpdateForm(false);
                    setSelectedPR(null);
                  }}
                  style={{
                    padding: "8px 16px",
                    backgroundColor: "#191056",
                    color: "white",
                    borderRadius: "5px",
                  }}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        )}

        <table className="table table-bordered">
          <thead>
            <tr className="table-dark">
              <th style={{ backgroundColor: "#111c43" }}>Vendor Name</th>
              <th style={{ backgroundColor: "#111c43" }}>PR No</th>
              <th style={{ backgroundColor: "#111c43" }}>Invoice No</th>
              <th style={{ backgroundColor: "#111c43" }}>PR Date</th>
              <th style={{ backgroundColor: "#111c43" }}>Net Payable</th>
              <th style={{ backgroundColor: "#111c43" }}>Status</th>
              <th style={{ backgroundColor: "#111c43" }}>Bank Name</th>
              <th
                style={{
                  backgroundColor: "#111c43",
                  textAlign: "center",
                  color: "white",
                  padding: "10px",
                }}
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {searchTerm && searchResults.length === 0 ? (
              <tr>
                <td
                  colSpan="7"
                  style={{
                    textAlign: "center",
                    color: "gray",
                    fontSize: "16px",
                  }}
                >
                  No Matching Payment Recommendations Found
                </td>
              </tr>
            ) : tableData.length === 0 ? (
              <tr>
                <td
                  colSpan="7"
                  style={{
                    textAlign: "center",
                    color: "gray",
                    fontSize: "16px",
                  }}
                >
                  No Payment Recommendations Available
                </td>
              </tr>
            ) : (
              (searchTerm ? searchResults : tableData).map((row) => {
                const isActive = activeRow === row.id; // Track which row's menu is open

                return (
                  <tr key={row.id}>
                    <td>{row.name}</td>
                    <td>{row.pr_no}</td>
                    <td>{row.invoice_no}</td>
                    <td>{new Date(row.pr_date).toLocaleDateString('en-GB')}</td>
                    <td>{row.net_payable}</td>
                    <td>{row.status}</td>
                    <td>{row.org_Bank_name || 'NA'}</td>
                    <td style={{ position: "relative", textAlign: "center" }}>
                      {/* Settings Icon Button */}
                      <button
                        style={{
                          padding: "8px",
                          backgroundColor: "transparent",
                          border: "none",
                          cursor: "pointer",
                        }}
                        onClick={() => setActiveRow(isActive ? null : row.id)} // Toggle active row
                      >
                        <FaCog size={20} color="#191056" />
                      </button>

                      {/* Pop-up menu with improved design */}
                      {activeRow === row.id && (
                        <div
                          ref={menuRef}
                          style={{
                            position: "absolute",
                            top: "40px",
                            right: "0",
                            backgroundColor: "white",
                            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                            borderRadius: "8px",
                            padding: "12px",
                            display: "grid",
                            gridTemplateColumns: "repeat(2, 1fr)", // Two buttons per row
                            gap: "8px",
                            zIndex: 10,
                            minWidth: "200px",
                          }}
                        >
                          {/* Popup Arrow Indicator */}
                          <div
                            style={{
                              position: "absolute",
                              top: "-10px",
                              right: "14px",
                              width: "0",
                              height: "0",
                              borderLeft: "10px solid transparent",
                              borderRight: "10px solid transparent",
                              borderBottom: "10px solid white",
                            }}
                          />

                          {/* Buttons inside pop-up */}
                          <button
                            onClick={() => handleUpdate(row.pid)}
                            className="popup-button"
                          >
                            Update
                          </button>
                          <button
                            onClick={() => handleChangeStatusClick(row.pid, row.organizations_pid)}
                            className="popup-button"
                          >
                            Change Status
                          </button>

                          <button
                            onClick={() => handleDeleteClick(row.pid)}
                            className="popup-button"
                          >
                            Delete
                          </button>
                          <button
                            onClick={() => handleDownloadClick(row)}
                            className="popup-button"
                          >
                            Download PDF
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
      <Footer />
      {/* CSS Styles */}
      <style>
        {`
    .popup-button {
      padding: 0px 8px;
      background-color: #191056;
      color: white;
      border: none;
      cursor: pointer;
      border-radius: 5px;
      font-size: 12px;
      transition: background-color 0.3s ease;
      text-align: center;
      width: 100%;
    }

    .popup-button:hover {
      background-color: #2a1a7a;
    }
  `}
      </style>
    </>
  );
};
export default PRList;